import { render, staticRenderFns } from "./ServicosPrestados.vue?vue&type=template&id=64318115"
import script from "./ServicosPrestados.vue?vue&type=script&lang=js"
export * from "./ServicosPrestados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports